import { NgModule } from "@angular/core";
import { BreadcrumbService } from "./services/breadcrumb.service";
import { TopBreadcrumbsComponent } from './components/top-breadcrumbs/top-breadcrumbs.component';
import { CommonModule } from "@angular/common";

import { ListboxModule } from 'primeng/listbox';
import { MenuModule } from "primeng/menu";

import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { BreadcrumbModule } from 'primeng/breadcrumb';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    ListboxModule,
    MenuModule,
    BreadcrumbModule

  ],
  providers: [BreadcrumbService],
  declarations: [
    TopBreadcrumbsComponent
  ],
  exports: [TopBreadcrumbsComponent]
})
export class BreadCrumbModule { }
